module.exports = __webpack_public_path__ + "static/media/welcome-challenges.31d581c9.png";